import { render, staticRenderFns } from "./BlockProduct.vue?vue&type=template&id=797e25bf"
import script from "./BlockProduct.vue?vue&type=script&lang=ts"
export * from "./BlockProduct.vue?vue&type=script&lang=ts"
import style0 from "./BlockProduct.vue?vue&type=style&index=0&id=797e25bf&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports